import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b3d8d2dd-4150-4941-b835-9e77a885faf1/workspace/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
// ignore-string-externalization
import "whatwg-fetch";
import { accessTokenManager, defaultWebgateHeaders } from "@mrkt/features/webgate-fetch";
import { toJSON, verifyResponse, API } from "./helpers";
export * from "./constants_DEPRECATED";
export { accessTokenManager, webgateFetch, webgateFetchJson } from "@mrkt/features/webgate-fetch";
var mapResponse = function(response) {
    return toJSON(verifyResponse(response));
};
// DO NOT USE THIS! USE webgateFetch instead!
export var webgate = new API({
    defaultHeaders: defaultWebgateHeaders,
    getAccessToken: accessTokenManager.get.bind(accessTokenManager),
    mapResponse: mapResponse
});
// DO NOT USE THIS! USE webgateFetch instead!
export var webapi = new API({
    baseUrl: "https://api.spotify.com",
    getAccessToken: accessTokenManager.get.bind(accessTokenManager),
    mapResponse: mapResponse
});
/** @deprecated use webapi instead */ export var webapiAnonymous = webapi;
// export legacy helpers
var request = webgate.request, get = webgate.get, post = webgate.post, put = webgate.put, patch = webgate.patch, del = webgate.delete;
export { request, get, post, put, patch, del };
export function webapiFetch(url) {
    return _webapiFetch.apply(this, arguments);
}
function _webapiFetch() {
    _webapiFetch = _async_to_generator(regeneratorRuntime.mark(function _callee(url) {
        var options, token, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
                    _ctx.next = 3;
                    return accessTokenManager.get();
                case 3:
                    token = _ctx.sent;
                    return _ctx.abrupt("return", fetch(url, _object_spread_props(_object_spread({}, options), {
                        credentials: "same-origin",
                        headers: _object_spread_props(_object_spread({
                            accept: "application/json",
                            "content-type": "application/json"
                        }, options.headers), {
                            authorization: "Bearer ".concat(token)
                        })
                    })));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _webapiFetch.apply(this, arguments);
}
